import { OrderDetails } from '@/components/dashboard/orders/OrderDetails';
import { DashboardHead } from '@/components/SEO/DashboardHead';

export function OrderDetailsPage() {
  return (
    <div className="container mx-auto py-6">
      <DashboardHead pageName="Order Details" />
      <OrderDetails />
    </div>
  );
}